import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface League {
  league_id: string;
  name_en?: string;
  title?: string;
}

interface DuplicatePickemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (leagueId: string) => void | Promise<void>;
  leagues: League[];
  isLoading?: boolean;
}

export function DuplicatePickemDialog({
  open,
  onOpenChange,
  onConfirm,
  leagues,
  isLoading = false,
}: DuplicatePickemDialogProps) {
  const [selectedLeagueId, setSelectedLeagueId] = useState<string>('');

  const handleConfirm = async () => {
    if (!selectedLeagueId) return;
    await onConfirm(selectedLeagueId);
    setSelectedLeagueId('');
    onOpenChange(false);
  };

  const handleCancel = () => {
    setSelectedLeagueId('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Duplicate Pickem</DialogTitle>
          <DialogDescription>
            Select a league to assign the duplicated pickem to. All questions and options will be
            copied.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2 py-4">
          <Label htmlFor="league-select">Target League *</Label>
          <Select value={selectedLeagueId} onValueChange={setSelectedLeagueId}>
            <SelectTrigger id="league-select">
              <SelectValue placeholder="Select a league" />
            </SelectTrigger>
            <SelectContent>
              {leagues.map(league => (
                <SelectItem key={league.league_id} value={league.league_id}>
                  {league.name_en || league.title || `League #${league.league_id}`}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!selectedLeagueId || isLoading}>
            {isLoading ? 'Duplicating...' : 'Duplicate Pickem'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
